module.exports = __webpack_public_path__ + "img/Google_Mail.d3d3dc6d.png";